export const currencies = [
  // --- Crypto ---
  'ADA',
  'ARB',
  'AVAX',
  'BCH',
  'BNB',
  'BTC',
  'DOGE',
  'DOT',
  'ETH',
  'FIL',
  'LINK',
  'LTC',
  'MATIC',
  'NEAR',
  'OP',
  'SOL',
  'TON',
  'TRX',
  'UNI',
  'XLM',
  'XMR',
  'XRP',

  // --- Stablecoins ---
  'USDT',
  'USDC',
  'DAI',
  'TUSD',
  'FDUSD',
  'USDP',
  'PYUSD',
  'GUSD',
  'BUSD',
  'EURT',
  'EUROC',
  'EURS',
  'CUSD',

  // --- Fiat ---
  'AED',
  'AUD',
  'ARS',
  'BDT',
  'BRL',
  'CAD',
  'CHF',
  'CLP',
  'COP',
  'CRC',
  'DKK',
  'EUR',
  'GBP',
  'GHS',
  'GTQ',
  'HKD',
  'IDR',
  'INR',
  'JPY',
  'KES',
  'KHR',
  'KRW',
  'LAK',
  'MMK',
  'MXN',
  'MYR',
  'NGN',
  'NOK',
  'NPR',
  'NZD',
  'PEN',
  'PHP',
  'PKR',
  'PLN',
  'RUB',
  'RWF',
  'SEK',
  'SGD',
  'THB',
  'TZS',
  'UGX',
  'USD',
  'UYU',
  'UZS',
  'VND',
  'XAF',
  'XOF',
  'ZAR',
  'ZMW',
  'ZWL',
]
